import { render, staticRenderFns } from "./DeleteMessagesModal.vue?vue&type=template&id=477a9e75"
import script from "./DeleteMessagesModal.vue?vue&type=script&lang=js"
export * from "./DeleteMessagesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports